import axios from "axios";

export const baseClient = () => {
	return axios.create();
};

export const authClient = (token) => {
	return axios.create({
		headers: {
			"Access-Control-Allow-Origin": "*",
			"Access-Control-Allow-Methods": "*",
			Authorization: `Bearer ${token}`,
		},
		"Access-Control-Allow-Credentials": true,
	});
}; 

const PRO =
	process.env.NODE_ENV === "production" || process.env.NODE_ENV === "pro";
const PRODUCTION_API = "http://192.168.105.11:8080/api";
const LOCAL_API = "https://localhost:7298/api";

// REACT_APP_API_URL permits testing against a remote API without changing code.
export const API = process.env.REACT_APP_API_URL || (PRO ? PRODUCTION_API : LOCAL_API);

export const SERVER_URL = process.env.REACT_APP_SERVER_URL || (PRO ? "" : "http://localhost:4001");
